import { usePage } from '../../context/PageContext';
import { fetchModelInstanceApi } from '../../hooks/api/useFetchModelInstance';
import { fetchCurrentModelSummaryApi } from '../../../hooks/useFetchCurrentModelSummary';

const useResolveModelVersionId = () => {
  const pageData = usePage();

  const resolveModelVersionId = async (data: {
    modelInstanceId?: string;
    _modelVersionId?: string;
    _modelId?: string;
    payload?: any;
  }) => {
    if (data.payload?._modelVersionId) {
      return data.payload._modelVersionId;
    }
    if (data._modelVersionId) {
      return data._modelVersionId;
    }
    if (data._modelId || data.payload?._modelId) {
      const model = await fetchCurrentModelSummaryApi(
        data._modelId || data.payload?._modelId
      );
      return model.id;
    }
    if (pageData.instance) {
      return pageData.instance.modelVersionId;
    }
    if (data.modelInstanceId) {
      const modelInstance = await fetchModelInstanceApi(data.modelInstanceId);
      return modelInstance.modelVersionId;
    }
    if (pageData.model) {
      return pageData.model.id;
    }
    return null;
  };
  return { resolveModelVersionId };
};

export default useResolveModelVersionId;
